// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.TextFileLoadBackupDialog[data-v-71f86419]
	{
		background-color: #FFFFFF;
		box-shadow: rgba(0,0,0,0.7) 2px 9px 20px 7px;
		min-width: 300px;
		max-width: calc(100vw - 50px);
		word-break: break-word;
		word-wrap: break-word;
}
.titleBar[data-v-71f86419]
	{
		background-color: #FFFFFF;
		padding: 8px 14px;
		box-sizing: border-box;
}
.title[data-v-71f86419]
	{
		text-align: center;
		color: black;
		font-weight: bold;
		font-size: 16pt;
}
.dialogBody[data-v-71f86419]
	{
		padding: 4px 16px 16px 16px;
		display: flex;
		flex-direction: column;
		align-items: center;
}
.loadBackupBtn[data-v-71f86419]
	{
		margin-bottom: 0.25em;
		background-color: transparent;
		border: none;
		color: var(--link-color);
		cursor: pointer;
		text-decoration: underline;
}
.controls[data-v-71f86419]
	{
		display: flex;
}
.dialogButton[data-v-71f86419]
	{
		display: inline-block;
		cursor: pointer;
		color: black;
		font-weight: bold;
		font-size: 12pt;
		box-sizing: border-box;
		position: relative;
		padding: 12px 5px;
		flex: 1 0 auto;
		text-align: center;
}
.dialogButton[data-v-71f86419]:hover
		{
			background-color: rgba(0,0,0,0.05);
}
.cancelButton[data-v-71f86419]
	{
		color: #CE7D29;
		border-left: 1px solid #DDDDDD;
}
`, "",{"version":3,"sources":["webpack://./www/vues/client/controls/TextFileLoadBackupPopup.vue"],"names":[],"mappings":";AAsDC;;EAEC,yBAAyB;EACzB,4CAA4C;EAC5C,gBAAgB;EAChB,6BAA6B;EAC7B,sBAAsB;EACtB,qBAAqB;AACtB;AAEA;;EAEC,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;AACvB;AAEA;;EAEC,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AAChB;AAEA;;EAEC,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACpB;AAEA;;EAEC,qBAAqB;EACrB,6BAA6B;EAC7B,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,0BAA0B;AAC3B;AAEA;;EAEC,aAAa;AACd;AAEA;;EAEC,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACnB;AAEC;;GAEC,kCAAkC;AACnC;AAED;;EAEC,cAAc;EACd,8BAA8B;AAC/B","sourcesContent":["<template>\r\n\t<div class=\"TextFileLoadBackupDialog\" role=\"alertdialog\" aria-labelledby=\"TextFileLoadBackupTitle\">\r\n\t\t<div class=\"titleBar\">\r\n\t\t\t<div class=\"title\" id=\"TextFileLoadBackupTitle\" role=\"alert\">Load Backup</div>\r\n\t\t</div>\r\n\t\t<div class=\"dialogBody\">\r\n\t\t\t<div class=\"backupList\">\r\n\t\t\t\t<div class=\"backupListItem\">\r\n\t\t\t\t\t<button class=\"loadBackupBtn\" @click=\"loadBackup(null)\">\r\n\t\t\t\t\t\tCurrent Version\r\n\t\t\t\t\t</button>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"backupListItem\" v-for=\"date in backupDates\" :key=\"date\">\r\n\t\t\t\t\t<button class=\"loadBackupBtn\" @click=\"loadBackup(date)\">\r\n\t\t\t\t\t\t{{new Date(date).toString()}}\r\n\t\t\t\t\t</button>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<div class=\"controls\">\r\n\t\t\t<div ref=\"btnCancel\" role=\"button\" class=\"dialogButton cencelButton\" tabindex=\"0\" @click=\"$emit('close', false)\" @keydown.space.enter.prevent=\"$emit('close', false)\" @keydown.left.prevent=\"FocusYes\">\r\n\t\t\t\tCancel\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n</template>\r\n<script>\r\n\texport default {\r\n\t\tprops:\r\n\t\t{\r\n\t\t\tbackupDates: {\r\n\t\t\t\ttype: Array,\r\n\t\t\t\trequired: true\r\n\t\t\t}\r\n\t\t},\r\n\t\tmethods:\r\n\t\t{\r\n\t\t\tSetFocus()\r\n\t\t\t{\r\n\t\t\t\tif (this.$refs.btnCancel)\r\n\t\t\t\t\tthis.$refs.btnCancel.focus();\r\n\t\t\t},\r\n\t\t\tDefaultClose()\r\n\t\t\t{\r\n\t\t\t\tthis.$emit('close', {});\r\n\t\t\t},\r\n\t\t\tloadBackup(date)\r\n\t\t\t{\r\n\t\t\t\tthis.$emit('close', { date });\r\n\t\t\t},\r\n\t\t},\r\n\t}\r\n</script>\r\n<style scoped>\r\n\t.TextFileLoadBackupDialog\r\n\t{\r\n\t\tbackground-color: #FFFFFF;\r\n\t\tbox-shadow: rgba(0,0,0,0.7) 2px 9px 20px 7px;\r\n\t\tmin-width: 300px;\r\n\t\tmax-width: calc(100vw - 50px);\r\n\t\tword-break: break-word;\r\n\t\tword-wrap: break-word;\r\n\t}\r\n\r\n\t.titleBar\r\n\t{\r\n\t\tbackground-color: #FFFFFF;\r\n\t\tpadding: 8px 14px;\r\n\t\tbox-sizing: border-box;\r\n\t}\r\n\r\n\t.title\r\n\t{\r\n\t\ttext-align: center;\r\n\t\tcolor: black;\r\n\t\tfont-weight: bold;\r\n\t\tfont-size: 16pt;\r\n\t}\r\n\r\n\t.dialogBody\r\n\t{\r\n\t\tpadding: 4px 16px 16px 16px;\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\talign-items: center;\r\n\t}\r\n\r\n\t.loadBackupBtn\r\n\t{\r\n\t\tmargin-bottom: 0.25em;\r\n\t\tbackground-color: transparent;\r\n\t\tborder: none;\r\n\t\tcolor: var(--link-color);\r\n\t\tcursor: pointer;\r\n\t\ttext-decoration: underline;\r\n\t}\r\n\r\n\t.controls\r\n\t{\r\n\t\tdisplay: flex;\r\n\t}\r\n\r\n\t.dialogButton\r\n\t{\r\n\t\tdisplay: inline-block;\r\n\t\tcursor: pointer;\r\n\t\tcolor: black;\r\n\t\tfont-weight: bold;\r\n\t\tfont-size: 12pt;\r\n\t\tbox-sizing: border-box;\r\n\t\tposition: relative;\r\n\t\tpadding: 12px 5px;\r\n\t\tflex: 1 0 auto;\r\n\t\ttext-align: center;\r\n\t}\r\n\r\n\t\t.dialogButton:hover\r\n\t\t{\r\n\t\t\tbackground-color: rgba(0,0,0,0.05);\r\n\t\t}\r\n\r\n\t.cancelButton\r\n\t{\r\n\t\tcolor: #CE7D29;\r\n\t\tborder-left: 1px solid #DDDDDD;\r\n\t}\r\n</style>\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
